export enum GLOBAL_UNIT {
  PRODUCTION_MMT = 5,
  AREA_MHA = 6,
  PRODUCTION_1000MT = 8,
  AREA_1000HA = 9,
  CROPVALUE_1000USD = 53,
  CROPVALUE_MUSD = 54,
  YIELD_MTHA = 7,
  DISPLAY_PRODUCTION = PRODUCTION_MMT,
  DISPLAY_AREA = AREA_MHA,
  DISPLAY_YIELD = YIELD_MTHA,
}

export function castUnit(value: number | null | undefined, currentUnit: GLOBAL_UNIT, displayUnit: GLOBAL_UNIT) {
  if (!value) {
    return value;
  }

  switch (currentUnit) {
    case GLOBAL_UNIT.PRODUCTION_1000MT:
    case GLOBAL_UNIT.AREA_1000HA:
    case GLOBAL_UNIT.CROPVALUE_1000USD:
      switch (displayUnit) {
        case GLOBAL_UNIT.AREA_MHA:
        case GLOBAL_UNIT.PRODUCTION_MMT:
        case GLOBAL_UNIT.CROPVALUE_MUSD :
          return value / 1000;
        default:
          return value;
      }
    case GLOBAL_UNIT.AREA_MHA:
    case GLOBAL_UNIT.PRODUCTION_MMT:
      switch (displayUnit) {
        case GLOBAL_UNIT.PRODUCTION_1000MT:
        case GLOBAL_UNIT.AREA_1000HA:
          return value * 1000;
        default:
          return value;
      }
    default:
      return value;
  }
}
